import { render } from "./ProfileType.vue?vue&type=template&id=61537afa&scoped=true"
import script from "./ProfileType.vue?vue&type=script&lang=js"
export * from "./ProfileType.vue?vue&type=script&lang=js"

import "./ProfileType.vue?vue&type=style&index=0&id=61537afa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61537afa"]])

export default __exports__